import {
  CalculatorOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  FileTextOutlined,
  FontSizeOutlined,
  NumberOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import React from 'react';

const FieldIcon = ({ fieldType }) => {
  const iconTypes = {
    TEXT: <FontSizeOutlined />,
    MULTI_LINE_TEXT: <FileTextOutlined />,
    NUMERIC: <NumberOutlined />,
    OPTIONS: <CheckCircleOutlined />,
    CHECKBOXES: <CheckSquareOutlined />,
    DATE: <CalendarOutlined />,
    ATTACHMENT: <PaperClipOutlined />,
    CALCULATION: <CalculatorOutlined />,
  };

  return iconTypes[fieldType];
};

export default FieldIcon;
